import * as React from 'react';
import GoalClick from './Icon/GoalClick';
import GoalEvent from './Icon/GoalEvent';
import GoalTransaction from './Icon/GoalTransaction';
import GoalVisitPage from './Icon/GoalVisitPage';
import { TriggerType } from '../../domain/entity/Goal';

interface IGoalTypeIconProps {
  type: TriggerType;
  size?: number;
}

class GoalTypeIcon extends React.PureComponent<IGoalTypeIconProps, {}> {
  public render() {
    switch (this.props.type) {
      case 'page_visit':
        return <GoalVisitPage size={this.props.size} />;
      case 'click':
        return <GoalClick size={this.props.size} />;
      case 'event':
        return <GoalEvent size={this.props.size} />;
      case 'transaction':
        return <GoalTransaction size={this.props.size} />;
      default:
        return null;
    }
  }
}

export default GoalTypeIcon;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/GoalTypeIcon.tsx